import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "list",
    "arrow",
    "hiddenInput",
    "summaryName",
    "summaryAddress",
    "summaryImage"
  ];

  static values = {
    expanded: { type: Boolean, default: false }
  }

  toggle() {
    this.expandedValue = !this.expandedValue;
  }

  expandedValueChanged(isExpanded) {
    if (!this.hasListTarget) return;

    if (isExpanded) {
      this.listTarget.style.transition = "height 0.5s ease-in-out";

      const height = this.listTarget.scrollHeight;
      this.listTarget.style.height = `${height}px`;

      const onEnd = () => {
        this.listTarget.removeEventListener("transitionend", onEnd);
        if (this.expandedValue) {
          this.listTarget.style.height = "auto";
        }
      };
      this.listTarget.addEventListener("transitionend", onEnd);

      if (this.hasArrowTarget) this.arrowTarget.style.transform = "rotate(0deg)";
    } else {
      if (this.listTarget.style.height === "auto") {
        this.listTarget.style.transition = "none";
        this.listTarget.style.height = `${this.listTarget.scrollHeight}px`;
        this.listTarget.offsetHeight;
      }

      this.listTarget.style.transition = "height 0.2s";
      this.listTarget.style.height = "0px";
      if (this.hasArrowTarget) this.arrowTarget.style.transform = "rotate(180deg)";
    }
  }

  select(event) {
    const button = event.currentTarget;
    const { locationId, locationName, locationAddress, locationImage } = button.dataset;

    if (this.hasHiddenInputTarget) this.hiddenInputTarget.value = locationId;
    if (this.hasSummaryNameTarget) this.summaryNameTarget.textContent = locationName;
    if (this.hasSummaryAddressTarget) this.summaryAddressTarget.textContent = locationAddress;
    if (this.hasSummaryImageTarget && locationImage) this.summaryImageTarget.src = locationImage;

    this.expandedValue = false;

    this.element.dispatchEvent(
      new CustomEvent("locationSelected", {
        detail: { id: locationId },
        bubbles: true,
      })
    );
  }
}
